import { InjectionToken } from '@angular/core';
import { RuntimeConfig } from './models/runtime-config';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>('RUNTIME_CONFIG');

export const WINDOW_TOKEN = new InjectionToken<Window>('WINDOW_TOKEN');
